<div
    #historyList
    class="flex size-full flex-col overflow-y-auto bg-surface-A p-12"
    interactaScrollTracker
    [scrollOffsetPx]="100"
    [wheelScrollOnly]="true"
    (scrolled)="onScroll($event)"
>
    @for (group of groupedHistory(); track group.group) {
        <section class="mb-16">
            @if (group.group !== 'ungrouped') {
                <h3 class="p-4 typo-xs-bold-uppercase text-text-mid-contrast">
                    {{ groupLabelKeys[group.group] | translate }}
                </h3>
            }

            <div class="flex flex-col gap-y-8" role="list">
                @for (item of group.items; track item.sessionId) {
                    <interacta-ai-convo-history-list-item
                        role="listitem"
                        [attr.aria-setsize]="-1"
                        [item]="item"
                        (deleteClick)="deleteClick.emit($event)"
                        (itemClick)="itemClick.emit($event)"
                        (renameClick)="renameClick.emit($event)"
                    />
                }
            </div>
        </section>
    }

    <div #loadMoreContainer>
        @if (
            history().nextPageToken.tag === 'regularLoading' ||
            history().isFetching
        ) {
            <interacta-load-more
                [isLoading]="history().isFetching"
                [label]="'SHARED.SHOW_MORE' | translate"
                [size]="'small'"
                (loadMore)="loadMore(history().nextPageToken, historyList)"
            />
        }
    </div>
</div>
